import {request} from '@/api';
import {Feed} from '@/api/models/Feeds.ts';
import {Create, Entity, Stub, Update} from '@/api/models/index.ts';

export interface Script extends Entity {
	feed: Stub<Feed, 'name'>,
	vinExtractionStrategy: ExtractionStrategy,
}

export enum StrategyKind {
	CssSelector = 'css-selector',
}

export const STRATEGY_VALUES = Object.values(StrategyKind).sort();

export const STRATEGY_NAMES: { [key in StrategyKind]: string } = {
	[StrategyKind.CssSelector]: 'CSS Selector',
};

interface BaseExtractionStrategy {
	kind: StrategyKind,
}

export interface CssSelectorStrategy extends BaseExtractionStrategy {
	kind: StrategyKind.CssSelector,
	selector: string,
}

export type ExtractionStrategy = CssSelectorStrategy;

export namespace Scripts {
	export function list(): Promise<Script[]> {
		return request('/scripts');
	}

	export function create(data: Create<Script>): Promise<Script> {
		return request('/scripts', {
			method: 'PUT',
			body: JSON.stringify(data),
		});
	}

	export function read(id: number): Promise<Script> {
		return request(`/scripts/${id}`);
	}

	export function update(id: number, data: Update<Script>): Promise<Script> {
		return request(`/scripts/${id}`, {
			method: 'PATCH',
			body: JSON.stringify(data),
		});
	}

	export function remove(id: number): Promise<void> {
		return request(`/scripts/${id}`, {
			method: 'DELETE',
		});
	}
}
